const MS4s = () => {
  const MS4sData = [
    {
      "agency": "Arapahoe County",
      "total_construction_sites": 44,
      "construction_inspections_count": 507,
      "construction_enforcement_count": 21,
      "construction_bmps_count": 0,
      "permanent_inspections_count": 3,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "Douglas County",
      "total_construction_sites": "1,127",
      "construction_inspections_count": "7,233",
      "construction_enforcement_count": 238,
      "construction_bmps_count": 10,
      "permanent_inspections_count": 6,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "City of Aurora",
      "total_construction_sites": 68,
      "construction_inspections_count": 552,
      "construction_enforcement_count": 21,
      "construction_bmps_count": 0,
      "permanent_inspections_count": 0,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "SEMSWA (City of Centennial)",
      "total_construction_sites": 78,
      "construction_inspections_count": 599,
      "construction_enforcement_count": 5,
      "construction_bmps_count": 15,
      "permanent_inspections_count": 26,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "City of Greenwood Village",
      "total_construction_sites": 1,
      "construction_inspections_count": 31,
      "construction_enforcement_count": "30*",
      "construction_bmps_count": 0,
      "permanent_inspections_count": 0,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "City of Lone Tree",
      "total_construction_sites": 2,
      "construction_inspections_count": 54,
      "construction_enforcement_count": 0,
      "construction_bmps_count": 2,
      "permanent_inspections_count": 4,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "City of Castle Pines",
      "total_construction_sites": 17,
      "construction_inspections_count": 160,
      "construction_enforcement_count": "122*",
      "construction_bmps_count": 6,
      "permanent_inspections_count": 6,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "Town of Castle Rock",
      "total_construction_sites": "1,636",
      "construction_inspections_count": "5,589",
      "construction_enforcement_count": "1,058",
      "construction_bmps_count": 3,
      "permanent_inspections_count": 319,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "Town of Parker",
      "total_construction_sites": 134,
      "construction_inspections_count": "1,932",
      "construction_enforcement_count": 39,
      "construction_bmps_count": 12,
      "permanent_inspections_count": 306,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "CDOT",
      "total_construction_sites": 3,
      "construction_inspections_count": 0,
      "construction_enforcement_count": 0,
      "construction_bmps_count": 0,
      "permanent_inspections_count": 0,
      "permanent_enforcement_count": 0
    }
  ];

   // Declare and configure request overview table
   const MS4sTable = new requestTable({
    container: "#ms4s-table",
    filterEnabled: false,
    tableHeaders: {
      "agency": "Agency",
      "total_construction_sites": "Total Construction Sites",
      "construction_inspections_count": "Construction Inspections",
      "construction_enforcement_count": "Construction Enforcements",
      "construction_bmps_count": "Permanent BMPs",
      "permanent_inspections_count": "Permanent Inspections",
      "permanent_enforcement_count": "Permanent Enforcements"
    },
    tableActions: [],
    tableData: MS4sData,
  });
  MS4sTable.buildTable();
};
